import { useEffect, useState } from 'react';
import { observeAccountMembers } from '../services/accountService';

export const useAccountMembers = (accountId, accountType) => {
  const [state, setState] = useState({ accountId: null, members: [], error: null });
  useEffect(() => {
    let active = true;
    if (!accountId) { setState({ accountId: null, members: [], error: null }); return () => { active = false; }; }
    const stop = observeAccountMembers(accountId, accountType, (members) => {
      if (active) setState({
        accountId,
        members: members.filter((member) => member?.linked !== false && Boolean(member?.uid || member?.id)),
        error: null,
      });
    }, (error) => {
      if (active) setState({ accountId, members: [], error });
    });
    return () => { active = false; stop(); };
  }, [accountId, accountType]);
  return state.accountId === accountId ? state : { accountId, members: [], error: null };
};
